// extracted by mini-css-extract-plugin
module.exports = {"indicator":"Indicator_indicator__5xUKX","hasExpired":"Indicator_hasExpired__2cwCc","aboutToExpire":"Indicator_aboutToExpire__1krgG"};